import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, FormControlLabel, Switch } from '@mui/material';
import { withRights } from 'providers/RightsConsumer';

const OfferAssetRematComponent = React.memo(({ t, rights, onPropertyChange, remat }) => {
  const changeRematValue = event => {
    let propertyValue;
    if (event.target.checked === true) propertyValue = '1';
    else propertyValue = '0';
    onPropertyChange('remat', propertyValue);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={4}>
        <FormControlLabel
          control={
            <Switch
              id={'offerAssetCard_remat'}
              checked={
                remat && (remat === '1' || remat.toLowerCase() === 'true' || remat.toLowerCase() === 'da' || remat.toLowerCase() === 'yes')
                  ? true
                  : false
              }
              onChange={changeRematValue}
              disabled={rights.readOnlyFull || !rights.financedAssetWrite}
            />
          }
          label={t('OfferEdit.Asset.Info.Remat')}
        />
      </Grid>
    </Grid>
  );
});

OfferAssetRematComponent.displayName = 'OfferAssetRematComponent';

OfferAssetRematComponent.propTypes = {
  t: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  remat: PropTypes.string.isRequired
};

export default withTranslation()(withRights(OfferAssetRematComponent));
